/**
 * Reverse lookup: Safety Manager points that map onto one Equipment.
 *
 * For each `(:Equipment)-[:MAPS_TO_SAFETY_POINT]->(:SafetyPoint)`:
 *   - `point`      — the SafetyPoint
 *   - `diagram`    — owning FunctionLogicDiagram
 *   - `solver`     — owning LogicSolver
 *   - `functions`  — ProtectiveFunctions that `IMPLEMENTED_BY` the point
 *
 * Bounded by `LIMIT 200` (one equipment's mapped points).
 */
export const PLANT_EQUIPMENT_SAFETY_POINTS_CYPHER = `
            MATCH (eq:Equipment {id: $equipmentId})-[:MAPS_TO_SAFETY_POINT]->(sp:SafetyPoint)
            OPTIONAL MATCH (fld:FunctionLogicDiagram)-[:CONTAINS]->(sp)
            OPTIONAL MATCH (ls:LogicSolver)-[:CONTAINS]->(fld)
            OPTIONAL MATCH (pf:ProtectiveFunction)-[:IMPLEMENTED_BY]->(sp)
            RETURN sp AS point,
                   fld AS diagram,
                   ls AS solver,
                   collect(distinct pf) AS functions
            ORDER BY toLower(coalesce(sp.name, sp.id))
            LIMIT 200
          `
